<template>
  <span class="ui-icon-tile" :class="[`ui-icon-tile--${size}`, `ui-icon-tile--${tone}`]">
    <component :is="icon" :size="ICON_SIZES[size]" :stroke-width="2" aria-hidden="true" />
  </span>
</template>

<script setup lang="ts">
import type { Component } from "vue";

const ICON_SIZES = { s: 16, m: 20, l: 24 } as const;

withDefaults(
  defineProps<{
    icon: Component;
    size?: "s" | "m" | "l";
    tone?: "accent" | "neutral";
  }>(),
  {
    size: "m",
    tone: "accent",
  },
);
</script>
